import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Grid, TextField, FormControl, InputLabel, Select, MenuItem,
    CircularProgress, Box, Chip
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { CriarGruposSchema } from '../schemes/CriacaoDeGrupos';;

export default function ModalCriacaoDeGrupos({ open, onClose, onSave, isLoading }) {

    const [filtros, setFiltros] = useState({
        nome: '',
        status: 'S',
    });

    const [erroNomegrupos, seterroNomegrupos] = useState(false);
    const [erroNomegruposMessage, seterroNomegruposMessage] = useState('');

    const [erroStatusGrupos, seterroStatusGrupos] = useState(false);
    const [erroStatusGruposMessage, seterroStatusGruposMessage] = useState('');


    const handleChange = (e) => {
        let { name, value } = e.target;
        setFiltros(prev => ({ ...prev, [name]: value }));

    };

    const handleSubmit = (e) => {
        e.preventDefault();
        let nome = filtros.nome;
        let status = filtros.status;

        const result = CriarGruposSchema.safeParse({ nome, status });

        if (!result.success) {
            const errors = result.error.format();

            if (errors.nome?._errors?.length) {
                seterroNomegrupos(true);
                seterroNomegruposMessage(errors.nome._errors[0]);
            } else {
                seterroNomegrupos(false);
                seterroNomegruposMessage('');
            }


            if (errors.status?._errors?.length) {
                seterroStatusGrupos(true)
                seterroStatusGruposMessage(errors.status._errors[0]);
            } else {
                seterroStatusGrupos(false)
                seterroStatusGruposMessage('');
            }
            return;
        }
        onSave(filtros);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Criar grupo</DialogTitle>
            <Box
                component="form"
                onSubmit={handleSubmit}
            >
                <DialogContent>
                    <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item
                            size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}
                        >
                            <TextField
                                fullWidth
                                name="nome"
                                value={filtros.nome}
                                onChange={handleChange}
                                label='Nome do produto'
                                variant="outlined"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                                required
                                error={erroNomegrupos}
                                helperText={erroNomegrupos ? erroNomegruposMessage : ''}
                            />
                        </Grid>

                        <Grid item size={{ sx: 1, sm: 12, md: 4, lg: 4, xl: 1, xs: 12 }}>
                            <TextField
                                select
                                fullWidth
                                label="Ativo"
                                name="status"
                                value={filtros.status === '' ? 'S' : filtros.status}
                                onChange={handleChange}
                                variant="outlined"
                                InputProps={{ sx: { backgroundColor: 'white', color: 'black' } }}
                                InputLabelProps={{ sx: { bgcolor: 'white', px: 0.5, color: 'black' } }}
                                required
                                error={erroStatusGrupos}
                                helperText={erroStatusGrupos ? erroStatusGruposMessage : ''}

                            >
                                <MenuItem value="S">Sim</MenuItem>
                                <MenuItem value="N">Não</MenuItem>
                            </TextField>
                        </Grid>

                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="secondary">Cancelar</Button>
                    <Button
                        type="submit"
                        variant="outlined"
                        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                        disabled={isLoading}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </Box>
        </Dialog>
    );
}